import { render, staticRenderFns } from "./addClerk.vue?vue&type=template&id=67378d2f&scoped=true"
import script from "./addClerk.vue?vue&type=script&lang=js"
export * from "./addClerk.vue?vue&type=script&lang=js"
import style0 from "./addClerk.vue?vue&type=style&index=0&id=67378d2f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67378d2f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\fenxijunya-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67378d2f')) {
      api.createRecord('67378d2f', component.options)
    } else {
      api.reload('67378d2f', component.options)
    }
    module.hot.accept("./addClerk.vue?vue&type=template&id=67378d2f&scoped=true", function () {
      api.rerender('67378d2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/merchant/collateUser/addClerk.vue"
export default component.exports